import { createSelector, createFeatureSelector } from "@ngrx/store";
import { MobileActivate } from "./activate.state";

export const activateStateSelector = createFeatureSelector<MobileActivate>("activate");

export const activateSelector = createSelector(activateStateSelector, (state) => state);
export const activateUserInfoSelector = createSelector(activateStateSelector, (state) => state?.cart);
export const activateSalesInfoSelector = createSelector(activateStateSelector, (state) => state?.sale);
export const activateUserDetailsSelector = createSelector(activateStateSelector, (state) => state?.validation?.customerDetails);
export const activateSimSelector = createSelector(activateStateSelector, (state) => state?.simNumber);
export const activatePUKSelector = createSelector(activateStateSelector, (state) => state?.product?.characteristic?.find(chars => chars.name === "PUK")?.value);
